import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'jhi-autocertificazioni',
  templateUrl: './autocertificazioni.component.html',
  styleUrls: ['./autocertificazioni.component.scss']
})
export class AutocertificazioniComponent implements OnInit {
  showMeStessoForm: boolean = true;
  showFamiliariForm: boolean = false;

  loading: boolean = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  showMeStesso() {
    this.showMeStessoForm = true;
    this.showFamiliariForm = false;
  }

  showFamiliari() {
    this.showFamiliariForm = true;
    this.showMeStessoForm = false;
  }
}
